import React from "react";
import { withRouter } from "react-router-dom";
import Page from "./Page";
import { paths } from "../../../paths";
import { labels } from "../../../../localization/labels";
import UserSession from "../../../../session/UserSession";
import PageComponent from "../PageComponent";
import CommonUtil from "../../../../utils/CommonUtil";
import SecurityUtil from "../../../../utils/SecurityUtils";
import { constants } from "../../../../utils/Constants";
import { BookOutlined, ToolOutlined } from "@ant-design/icons";
import PathUtil from "../../../../utils/PathUtil";

const HttpStatus = require("http-status-codes");

class PageContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.messageAlert = React.createRef();
    this.breadcrumbs = React.createRef();

    this.state = {
      sideMenuCollapsed: false,
      sideMenuItems: []
    };

    this.breadcrumbTasks = [];
  }

  getComponentTitle = () => {
    return undefined;
  };

  messageHandler = {
    _canUseAlert: () => {
      return (
        this.messageAlert !== undefined &&
        this.messageAlert.current !== undefined &&
        this.messageAlert !== null &&
        this.messageAlert.current !== null
      );
    },

    handleSuccess: message => {
      if (this.messageHandler._canUseAlert()) {
        this.messageAlert.current.showSuccessMessage(message);
      }
    },

    handleWarning: message => {
      if (this.messageHandler._canUseAlert()) {
        this.messageAlert.current.showWarningMessage(message);
      }
    },

    handleError: message => {
      if (message.status === HttpStatus.UNAUTHORIZED) {
        UserSession.deleteUserSession();
        this.changePath(paths.LOGIN_PATH, undefined, {
          message: message
        });
      } else {
        if (this.messageHandler._canUseAlert()) {
          this.messageAlert.current.showErrorMessage(message);
        }
      }
    },

    unhandle: () => {
      if (this.messageHandler._canUseAlert()) {
        this.messageAlert.current.dismissAlert();
      }
    }
  };

  breadcrumbsHandler = {
    _canUseBreadcrumbs: () => {
      return (
        this.breadcrumbs !== undefined &&
        this.breadcrumbs.current !== undefined &&
        this.breadcrumbs !== null &&
        this.breadcrumbs.current !== null
      );
    },
    addBreadcrumb: (path, name) => {
      if (this.breadcrumbsHandler._canUseBreadcrumbs()) {
        this.breadcrumbs.current.push(path, name);
      } else {
        this.breadcrumbTasks.push({ action: "ADD", path: path, name: name });
      }
    },
    resetBreadcrumb: (path, name) => {
      if (this.breadcrumbsHandler._canUseBreadcrumbs()) {
        this.breadcrumbs.current.restart(path, name);
      } else {
        this.breadcrumbTasks.push({ action: "RESET", path: path, name: name });
      }
    },
    gotoBreadcrumb: (path, name) => {
      if (this.breadcrumbsHandler._canUseBreadcrumbs()) {
        this.breadcrumbs.current.pop(path, name);
      } else {
        this.breadcrumbTasks.push({ action: "GOTO", path: path, name: name });
      }
    },
    revertBreadcrumb: () => {
      if (this.breadcrumbsHandler._canUseBreadcrumbs()) {
        this.breadcrumbs.current.pop();
      } else {
        this.breadcrumbTasks.push({ action: "REVERT" });
      }
    },
    refreshBreadcrumb: (path, name) => {
      if (this.breadcrumbsHandler._canUseBreadcrumbs()) {
        this.breadcrumbs.current.refresh(path, name);
      } else {
        this.breadcrumbTasks.push({
          action: "REFRESH",
          path: path,
          name: name
        });
      }
    },
    getBreadcrumbPosition: path => {
      if (this.breadcrumbsHandler._canUseBreadcrumbs()) {
        return this.breadcrumbs.current.position(path);
      }
      return -1;
    }
  };

  updateBreadcrumb = () => {
    const tasks = this.breadcrumbTasks;
    if (tasks.length > 0) {
      for (var i = 0; i < tasks.length; i++) {
        const task = tasks[i];

        switch (task.action) {
          case "ADD":
            this.breadcrumbsHandler.addBreadcrumb(task.path, task.name);
            break;
          case "RESET":
            this.breadcrumbsHandler.resetBreadcrumb(task.path, task.name);
            break;
          case "GOTO":
            this.breadcrumbsHandler.gotoBreadcrumb(task.path, task.name);
            break;
          case "REVERT":
            this.breadcrumbsHandler.revertBreadcrumb();
            break;
          case "REFRESH":
            this.breadcrumbsHandler.refreshBreadcrumb(task.path, task.name);
            break;
          default:
            break;
        }
      }
      this.breadcrumbTasks = [];
    }
  };

  onBreadcrumbClick = (path, name) => {
    const breadcrumbPosition = this.breadcrumbsHandler.getBreadcrumbPosition(
      path
    );
    this.changePath(path, name, {}, breadcrumbPosition);
  };

  componentDidUpdate() {
    this.updateBreadcrumb();
  }

  onSideMenuToggle = () => {
    this.setState({ sideMenuCollapsed: !this.state.sideMenuCollapsed });
  };

  componentDidMount() {
    if (!UserSession.isUserLoggedIn()) {
      this.changePath(paths.LOGIN_PATH);
    } else {
      this.constructMenuItems();
    }
  }

  constructStaticMenuItems() {
    const menuItemArray = [
      {
        key: paths.KNOWLEDGE_MANAGMENT,
        label: labels.knowledgeManagement,
        icon: <BookOutlined />
      },
      {
        label: labels.administration,
        icon: <ToolOutlined />,
        content: [
          {
            label: labels.usersAndSecurity,
            content: [
              {
                key: PathUtil.adminPath(paths.USERS),
                label: labels.users,
                processes: [constants.OPERATION_SECURITY_ADMINISTRATION]
              },
              {
                key: PathUtil.adminPath(paths.INVOLVEMENTROLETYPES),
                label: labels.involvementRoleTypes,
                processes: [constants.OPERATION_SECURITY_ADMINISTRATION]
              },
              {
                key: PathUtil.adminPath(paths.ROLES),
                label: labels.roleTypes,
                processes: [constants.OPERATION_SECURITY_ADMINISTRATION]
              }
            ]
          },
          {
            label: labels.entities,
            content: [
              {
                key: PathUtil.adminPath(paths.LIFE_CYCLE),
                label: labels.lifeCycle,
                processes: [constants.OPERATION_ENTITY_ADMINISTRATION]
              },
              {
                key: PathUtil.adminPath(paths.CLASSIFICATIONS),
                label: labels.classification,
                processes: [constants.OPERATION_ENTITY_ADMINISTRATION]
              },
              {
                key: PathUtil.adminPath(paths.MESSAGE_LOG_TYPE),
                label: labels.messageLogType,
                processes: [constants.OPERATION_ENTITY_ADMINISTRATION]
              },
              {
                key: PathUtil.adminPath(paths.EXTENSION),
                label: labels.extensions,
                processes: [constants.OPERATION_ENTITY_ADMINISTRATION]
              }
            ]
          },

          {
            key: PathUtil.adminPath(paths.KNOWLEDGE),
            label: labels.knowledge,
            processes: [constants.OPERATION_KNOWLEDGE_ADMINISTRATION]
          }
        ]
      }
    ];

    this.filterMenuItemArray(menuItemArray);
    return menuItemArray;
  }

  filterMenuItemArray = menuItemArray => {
    if (menuItemArray && menuItemArray.length > 0) {
      for (let i = 0; i < menuItemArray.length; i++) {
        const element = menuItemArray[i];
        if (element.content) {
          this.filterMenuItemArray(element.content);
        }
        if (element.content && element.content.length === 0) {
          CommonUtil.removeElementFromArray(menuItemArray, element);
          i--;
        }
        if (element.processes) {
          if (!SecurityUtil.checkUserHasAnyOfProcesses(element.processes)) {
            CommonUtil.removeElementFromArray(menuItemArray, element);
            i--;
          }
        }
      }
    }
  };

  constructMenuItems() {
    const staticItems = this.constructStaticMenuItems();

    var menuItems = staticItems;
    this.setState({ sideMenuItems: menuItems });
  }

  onMenuItemClick = selected => {
    const path = selected.key;
    var from = this.props.location.pathname === path ? path : undefined;
    this.changePath(path, selected.label, {
      from: from
    });
  };

  render() {
    return (
      <Page
        sideMenuItems={this.state.sideMenuItems}
        sideMenuCollapsed={this.state.sideMenuCollapsed}
        onMenuItemClick={this.onMenuItemClick}
        location={this.props.location}
        onSideMenuToggle={this.onSideMenuToggle}
        alertRef={this.messageAlert}
        breadcrumbsRef={this.breadcrumbs}
        onBreadcrumbClick={this.onBreadcrumbClick}
        {...this.handlerProps()}
      />
    );
  }
}

export default withRouter(PageContainer);
